'use strict'; //

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../core/component"));

var _tools = _interopRequireDefault(require("../libs/tools"));

var _pullAt = _interopRequireDefault(require("lodash/pullAt"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * http请求
 */
var Http = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Http, _Component);

  function Http(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      ajaxList: []
    };

    _this.handlerLoading = function (loading) {
      _this._emit("Loading", loading);
    };

    _this.handlerComplete = function (request) {
      var index = _this.state.ajaxList.findIndex(request);

      (0, _pullAt.default)(_this.state.ajaxList, index);
    };

    _this.send = function (url, data, options) {
      var request = _tools.default.http(url, data, options).loading(_this.handlerLoading);

      _this.state.ajaxList.push(request);

      return request;
    };

    _this.delete = function (url, data, options) {
      var request = _tools.default.delete(url, data).loading(_this.handlerLoading);

      _this.state.ajaxList.push(request);

      return request;
    };

    _this.get = function (url, data, options) {
      var request = _tools.default.get(url, data, options).loading(_this.handlerLoading);

      _this.state.ajaxList.push(request);

      return request;
    };

    _this.post = function (url, data) {
      var request = _tools.default.post(url, data).loading(_this.handlerLoading);

      _this.state.ajaxList.push(request);

      return request;
    };

    _this.put = function (url, data) {
      var request = _tools.default.put(url, data).loading(_this.handlerLoading);

      _this.state.ajaxList.push(request);

      return request;
    };

    _this.patch = function (url, data) {
      var request = _tools.default.patch(url, data).loading(_this.handlerLoading);

      _this.state.ajaxList.push(request);

      return request;
    };

    _this.jsonp = function (url, data) {
      var request = _tools.default.jsonp(url, data).loading(_this.handlerLoading);

      _this.state.ajaxList.push(request);

      return request;
    };

    return _this;
  }
  /**
   * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
   */


  var _proto = Http.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.url) {
      var request = _tools.default.http(this.props.url, this.props.data).success(this.props.onSuccess).error(this.props.onError).complete(this.props.onComplete).loading(this.handlerLoading);

      this.state.ajaxList.push(request);
    }
  }
  /**
   *
   * @param loading
   * @private
   */
  ;

  /**
   * 在组件从 DOM 中移除的时候立刻被调用。
   */
  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this2 = this;

    this.state.ajaxList.forEach(function (xhr) {
      _this2._emit("Loading", false);

      try {
        xhr.stop();
      } catch (e) {}
    });
    this.state.ajaxList = [];
  }
  /**
   *
   * @returns {null}
   */
  ;

  _proto.render = function render() {
    return null;
  }
  /**ss
   *
   * @param url
   * @param data
   * @param options
   */
  ;

  return Http;
}(_component.default);

Http.displayName = "Http";
var _default = Http;
exports.default = _default;
module.exports = exports.default;